export const BOOKING_VIEWS = {
    CALENDAR: 'Calendar',
    TIME_PICKER: 'TimePicker',
    CUSTOMER_VIEW: 'CustomerView',
    PAYMENT_ACTION_VIEW: 'PaymentActionView',
    CUSTOMER_INFO_AND_PAYMENT: 'CustomerInfoAndPayment',
    OFFERS: 'Offers',
};
